import { useState, useMemo } from 'react';
import { C } from '../../lib/tokens.js';
import { t } from '../../lib/data.js';
import { useInvoices } from '../../lib/useBusinessData.js';
import { dateLong } from '../../lib/utils.js';
import { Button } from '../../components/ui/Button.jsx';
import { DocStatusChip } from '../../components/ui/Chips.jsx';
import { MoneyCell } from '../../components/ui/Misc.jsx';
import { PageShell } from '../../components/layout/PageShell.jsx';
import { matches, exportCsv, SearchInput, SimpleTable, RowActions } from './shared.jsx';

export function InvoicesPage() {
  const [search, setSearch] = useState('');
  const { invoices, loading } = useInvoices();
  const filtered = useMemo(() => invoices.filter(r => matches(search, r.no, r.desc)), [invoices, search]);

  const cols = [
    { key: 'no',     label: 'Invoice No.', render: r => <a style={{ color: C.liquid, fontWeight: 500, fontFamily: 'Roboto Mono' }}>{r.no}</a> },
    { key: 'status', label: 'Payment Status', render: r => <DocStatusChip id={r.status} size="sm" /> },
    { key: 'desc',   label: 'Description',    csvValue: r => r.desc || '', render: r => <span style={{ color: C.fg }}>{r.desc || <span style={{ color: C.silver, fontStyle: 'italic' }}>—</span>}</span> },
    { key: 'date',   label: 'Date',           render: r => <span style={{ color: C.iron }}>{dateLong(r.date)}</span> },
    { key: 'total',  label: 'Total incl. VAT', align: 'right', csvValue: r => r.total, render: r => <MoneyCell amount={r.total} currency={r.currency} /> },
    { key: 'actions', label: '', width: 80, align: 'right', render: r => <RowActions kind="invoice" id={r.id} no={r.no} /> },
  ];

  return (
    <PageShell title={t('nav.invoices')} subtitle="Invoices issued by ActFact to your company."
      actions={
        <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
          <SearchInput value={search} onChange={setSearch} placeholder="Search invoice no., description…" />
          <Button kind="outline" icon="download" onClick={() => exportCsv(filtered, cols, 'invoices.csv')}>Export CSV</Button>
        </div>
      }>
      <SimpleTable columns={cols} rows={filtered} loading={loading} />
    </PageShell>
  );
}
